(() => {
  'use strict';
  const countries = value => String(value || '').toUpperCase().split(',').map(x => x.trim()).filter(Boolean);
  const deadline = value => {
    if (!value) return null;
    // Require an explicit UTC offset: a visitor's device timezone must not change a campaign.
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    return Date.parse(value);
  };
  const day = 86400000;
  const easterDate = year => {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    return {month:Math.floor((h+l-7*m+114)/31)-1,date:(h+l-7*m+114)%31+1};
  };
  const annualWindow = (occasion, now, offset='+03:00') => {
    const valid=/^([+-])(0\d|1[0-4]):([0-5]\d)$/.exec(offset);
    if(!valid || valid[2]==='14' && valid[3]!=='00') return null;
    const minutes=(Number(valid[2])*60+Number(valid[3]))*(valid[1]==='-'?-1:1), year=new Date(now+minutes*60000).getUTCFullYear();
    for(const y of [year,year+1]) {
      let month,date;
      if(occasion==='halloween'){month=9;date=31;}
      else if(occasion==='christmas'){month=11;date=25;}
      else if(occasion==='new_year'){month=0;date=1;}
      else if(occasion==='valentine'){month=1;date=14;}
      else if(occasion==='easter'){({month,date}=easterDate(y));}
      else if(occasion==='black_friday'||occasion==='cyber_monday'){
        month=10;const first=new Date(Date.UTC(y,10,1)).getUTCDay();
        date=1+(4-first+7)%7+21+1+(occasion==='cyber_monday'?3:0);
      } else return null;
      const event=Date.UTC(y,month,date)-minutes*60000,end=event+day;
      if(now>=end) continue;
      const lead=occasion==='black_friday'||occasion==='cyber_monday'?7:30;
      return {start:event-lead*day,end,event,target:now<event?event:end,phase:now<event?'starts':'ends',lead};
    }
    return null;
  };
  const campaignWindow = (slide, now) => {
    if(slide.occasion && slide.occasion!=='manual') return annualWindow(slide.occasion,now,slide.offset || '+03:00');
    return {start:deadline(slide.start),end:deadline(slide.end),target:deadline(slide.end),phase:'ends'};
  };
  const eligible = (slide, country, now) => {
    const range=campaignWindow(slide,now);if(!range) return false;
    const {start,end}=range,codes=countries(slide.countries);
    return (!codes.length || codes.includes(country)) && (start === null || Number.isFinite(start) && now >= start) && (end === null || Number.isFinite(end) && now < end);
  };
  const choose = (slides, country, now, mix) => {
    const active = slides.filter(s => eligible(s, country, now)).sort((a, b) => b.priority - a.priority || a.order - b.order);
    const campaigns = active.filter(s => s.kind === 'campaign');
    const exclusive = campaigns.find(s => s.exclusive);
    return exclusive ? campaigns.filter(s => s.priority >= exclusive.priority) : !mix && campaigns.length ? campaigns : active;
  };
  const shippingStatus = (cart, config) => {
    if (!config.enabled || !cart || !Array.isArray(cart.items) || cart.currency !== config.currency) return null;
    // The published rate uses the discounted order subtotal. Avoid a misleading promise
    // for mixed digital/physical orders or when the destination hasn't been confirmed.
    if (cart.items.some(item => !item.requires_shipping || item.gift_card)) return null;
    const rule = config.rules.find(r => r.verified && r.currency === cart.currency && countries(r.countries).includes(config.country));
    let threshold = rule?.threshold;
    if (!threshold && cart.currency === 'USD' && countries(config.countries).includes(config.country)) threshold = config.threshold;
    if (!(threshold > 0) || !Number.isFinite(cart.total_price) || cart.total_price < 0) return null;
    return {threshold, remaining:Math.max(0, threshold - cart.total_price), subtotal:cart.total_price, unlocked:cart.total_price >= threshold};
  };
  const hasBaseShippingOffer = (cart, config) => Boolean(config.enabled && config.threshold > 0 && countries(config.countries).includes(config.country) && cart && cart.currency === config.currency && Array.isArray(cart.items) && cart.items.every(item => item.requires_shipping && !item.gift_card));
  if (typeof module !== 'undefined' && module.exports) module.exports = {deadline, eligible, choose, shippingStatus, hasBaseShippingOffer, annualWindow, easterDate, campaignWindow};
  if (typeof customElements === 'undefined' || customElements.get('mk-announcement')) return;
  class Announcement extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.design = this.dataset.designMode === 'true';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.stage = this.querySelector('.mka-stage');
      this.slides = [...this.querySelectorAll('[data-slide]')].map((el, order) => ({el,order,id:el.dataset.id,kind:el.dataset.kind,theme:el.dataset.theme,occasion:el.dataset.occasion,offset:this.dataset.eventOffset,priority:Number(el.dataset.priority),start:el.dataset.start,end:el.dataset.end,countries:el.dataset.countries,exclusive:el.dataset.exclusive === 'true'}));
      this.current = null;
      this.config = {enabled:this.dataset.shippingEnabled === 'true',country:this.dataset.country,currency:this.dataset.currency,threshold:Number(this.dataset.threshold),countries:this.dataset.shippingCountries,rules:JSON.parse(this.querySelector('[data-shipping-rules]').textContent)};
      this.cart = JSON.parse(this.querySelector('[data-initial-cart]').textContent);
      this.querySelector('[data-prev]').addEventListener('click', () => this.navigate(-1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.navigate(1), {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); this.navigate(e.key === 'ArrowRight' ? 1 : -1);}
      }, {signal});
      if (this.dataset.gestures === 'true') this.gestures(signal);
      document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh(); this.arm();}, {signal});
      this.motion.addEventListener('change', () => this.arm(), {signal});
      for (const name of ['cart:drawer:render','cart:count:update','cart:updated','cart:refresh','custom:cart:update','cart:change']) document.addEventListener(name, () => this.queueCart(), {signal});
      window.addEventListener('pageshow', () => this.queueCart(), {signal});
      window.addEventListener('focus', () => this.queueCart(), {signal});
      // Observe completed cart writes without replacing fetch or interfering with theme requests.
      if ('PerformanceObserver' in window) {
        this.resources = new PerformanceObserver(list => {
          if (list.getEntries().some(e => /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(e.name))) this.queueCart();
        });
        try {this.resources.observe({type:'resource'});} catch (_) {this.resources.disconnect();}
      }
      if (this.design) document.addEventListener('shopify:block:select', e => {
        const selected = this.slides.find(s => s.id === e.detail.blockId);
        if (selected && selected.kind !== 'shipping_rule') {this.hidden=false;this.active=[...new Set([...this.active,selected])];this.show(selected);this.arm();}
      }, {signal});
      this.copyMeasurements = new Map();
      this.fontVersion = 0;
      this.resize = new ResizeObserver(() => {
        // Hidden transitions already queue their zero offset. Ignore the later native
        // observer delivery once that commit is complete (there is no visible fit).
        if (!this.hidden || document.documentElement.style.getPropertyValue('--announcement-bar-height')!=='0px') this.fitCopy();
      });
      this.resize.observe(this);this.resize.observe(this.stage);
      window.addEventListener('resize', () => this.fitCopy(), {signal});
      const fontsChanged = () => {if (!signal.aborted) {this.fontVersion++;this.fitCopy();}};
      document.fonts?.ready.then(fontsChanged);
      document.fonts?.addEventListener('loadingdone', fontsChanged, {signal});
      this.centerIcons();this.refresh(true); this.updateShipping();this.dataset.ready='true';
      this.clock = setInterval(() => {if (!document.hidden) {this.refresh();this.timers();}},1000);
      this.queueCart();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller=null;
      clearInterval(this.clock); clearTimeout(this.auto); clearTimeout(this.cartDelay);
      this.querySelectorAll('.mka-copy').forEach(el=>{
        el.copyUpdate=null;el.pendingFull=null;
        el.getAnimations().forEach(animation=>animation.cancel());
      });
      this.resize?.disconnect();this.resources?.disconnect();
      cancelAnimationFrame(this.layoutFrame);this.layoutFrame=0;this.layoutBusy=false;this.layoutPending=false;
      this.copyMeasurements?.clear();
      for (const name of ['--mka-offset','--announcement-bar-height']) {
        if (document.documentElement.style.getPropertyValue(name)!=='0px') document.documentElement.style.setProperty(name,'0px');
      }
    }
    refresh(initial = false) {
      const next = choose(this.slides,this.dataset.country,Date.now(),this.dataset.mix === 'true');
      const changed = next.map(s=>s.id).join('|') !== this.active?.map(s=>s.id).join('|');
      this.active = next;
      if (!next.length) {if (!this.hidden) {this.hidden=true;this.offset();}return;}
      if (this.hidden) this.hidden=false;
      if (initial || changed || !next.includes(this.current)) this.show(next[0],true);
      const single = next.length < 2;
      this.querySelectorAll('[data-prev],[data-next]').forEach(button => {
        if (button.getAttribute('aria-disabled')!==String(single)) button.setAttribute('aria-disabled',String(single));
        if (button.disabled!==single) button.disabled=single;
      });
      if (initial || changed) this.arm();
    }
    show(slide, immediate = false) {
      if (!slide || this.current === slide && !immediate) return;
      // Capture focus before inert/visibility writes can move it to the document.
      const oldLinkFocused = this.current?.el.contains(document.activeElement);
      this.slides.forEach(s => {
        const active = s === slide;
        s.el.classList.toggle('is-active',active);s.el.setAttribute('aria-hidden',String(!active));
        s.el.inert = !active;
        s.el.querySelectorAll('a').forEach(a=>{a.tabIndex=active ? 0 : -1;});
      });
      this.querySelectorAll('[data-surface]').forEach(surface=>surface.classList.toggle('is-active',surface.dataset.surface === slide.id));
      // A focused link must never become hidden while the customer is using it.
      this.current=slide;this.dataset.theme=slide.theme;
      if (oldLinkFocused) slide.el.querySelector('a')?.focus({preventScroll:true});
      this.timers();this.fitCopy();
    }
    navigate(delta) {
      if (this.active.length < 2) return;
      const direction = document.documentElement.dir === 'rtl' ? -delta : delta;
      const index=this.active.indexOf(this.current);
      this.show(this.active[(index+direction+this.active.length)%this.active.length]);this.arm();
    }
    arm() {
      clearTimeout(this.auto);
      if (!this.isConnected || this.hidden || this.motion.matches || this.dataset.autoplay !== 'true' || document.hidden || this.active?.length < 2) return;
      const delay=Number(this.dataset.interval)||3000;
      this.auto=setTimeout(()=>{
        this.show(this.active[(this.active.indexOf(this.current)+1)%this.active.length]);this.arm();
      },delay);
    }
    timers() {
      const now=Date.now();let layoutChanged=false;
      const setText=(el,text)=>{
        const previous=el.textContent;
        if (previous===text) return;
        if (el.childNodes.length===1 && el.firstChild.nodeType===Node.TEXT_NODE) el.firstChild.nodeValue=text;
        else el.textContent=text;
        // Countdown numerals are tabular in the existing CSS. Only digit-count or
        // phase changes can change their reserved width; seconds alone need no layout.
        if (!el.hasAttribute('data-time') || previous.length!==text.length) layoutChanged=true;
      };
      this.slides.forEach(s=>{
        const el=s.el.querySelector('[data-timer]');
        const range=campaignWindow(s,now),end=range?.target;
        const enabled=s.kind==='campaign' && (s.occasion&&s.occasion!=='manual'||s.el.dataset.countdown==='true') && Number.isFinite(end) && end>now;
        if (el.hidden===Boolean(enabled)) {el.hidden=!enabled;layoutChanged=true;}
        if (!enabled || s !== this.current) return;
        if(!el.childElementCount) {el.innerHTML='<span class="mka-clock-phase"></span>'+[['d','days'],['h','hrs'],['m','min'],['s','sec']].map(([unit,label])=>`<span class="mka-time-unit"><b data-time="${unit}">00</b><small><span class="mka-time-full">${label}</span><span class="mka-time-short">${unit}</span></small></span>`).join('');layoutChanged=true;}
        const seconds=Math.max(0,Math.ceil((end-now)/1000));
        const units=[['d',Math.floor(seconds/86400)],['h',Math.floor(seconds/3600)%24],['m',Math.floor(seconds/60)%60],['s',seconds%60]];
        for(const [unit,value] of units) setText(el.querySelector(`[data-time="${unit}"]`),String(value).padStart(2,'0'));
        setText(el.querySelector('.mka-clock-phase'),range.phase==='starts'?'In':'Ends in');
        const label=`${range.phase==='starts'?'Starts':'Ends'} in ${units[0][1]} days, ${units[1][1]} hours, ${units[2][1]} minutes, ${units[3][1]} seconds`;
        if (el.getAttribute('aria-label')!==label) el.setAttribute('aria-label',label);
        if (el.title!==label) el.title=label;
      });
      if (layoutChanged) this.fitCopy();
    }
    centerIcons() {
      this.iconsPending=true;this.fitCopy();
    }
    gestures(signal) {
      this.stage.addEventListener('pointerdown',e=>{
        if (!e.isPrimary || e.button !== 0) return;
        this.pointer={id:e.pointerId,x:e.clientX,y:e.clientY,dragged:false};
      },{signal});
      window.addEventListener('pointermove',e=>{
        const p=this.pointer;if (!p||p.id!==e.pointerId) return;
        const dx=e.clientX-p.x,dy=e.clientY-p.y;
        if (Math.abs(dy)>12 && Math.abs(dy)>Math.abs(dx)) {this.pointer=null;return;}
        if (Math.abs(dx)>8 && Math.abs(dx)>Math.abs(dy)*1.3) {p.dragged=true;this.stage.classList.add('is-dragging');}
      },{signal,passive:true});
      const finish=e=>{
        const p=this.pointer;if (!p || p.id!==e.pointerId) return;
        this.pointer=null;this.stage.classList.remove('is-dragging');
        if (p.dragged) {
          this.suppressClickUntil=Date.now()+500;
          if (e.type!=='pointercancel' && Math.abs(e.clientX-p.x)>30) this.navigate(e.clientX<p.x ? 1 : -1);
        }
      };
      window.addEventListener('pointerup',finish,{signal});window.addEventListener('pointercancel',finish,{signal});
      this.stage.addEventListener('click',e=>{if (Date.now()<this.suppressClickUntil) {e.preventDefault();e.stopPropagation();}}, {signal,capture:true});
      this.stage.addEventListener('dragstart',e=>e.preventDefault(),{signal});
    }
    queueCart() {
      if (!this.config.enabled || document.hidden) return;
      clearTimeout(this.cartDelay);this.cartDelay=setTimeout(()=>this.readCart(),180);
    }
    async readCart() {
      if (this.loadingCart) {this.cartAgain=true;return;}
      this.loadingCart=true;
      try {
        const root=window.Shopify?.routes?.root || '/';
        const response=await fetch(`${root}cart.js`,{credentials:'same-origin',headers:{Accept:'application/json'},signal:this.controller.signal,cache:'no-store'});
        if (!response.ok) throw new Error('Cart unavailable');
        this.cart=await response.json();this.updateShipping();
      } catch (_) {if(this.isConnected) this.updateShipping(true);}
      finally {this.loadingCart=false;if(this.cartAgain && this.isConnected){this.cartAgain=false;this.queueCart();}}
    }
    updateShipping(error = false) {
      const status=error ? null : shippingStatus(this.cart,this.config);
      const money=value=>new Intl.NumberFormat(this.dataset.locale || 'en',{style:'currency',currency:this.config.currency,currencyDisplay:'code',maximumFractionDigits:2}).format(value/100);
      let text='Delivery details & shipping rates';
      let short='Shipping & delivery details';
      if (!error && hasBaseShippingOffer(this.cart,this.config)) {
        const usd=new Intl.NumberFormat('en-US',{maximumFractionDigits:2}).format(this.config.threshold/100);
        text=`Free shipping on orders US$${usd}+ · See delivery details`;
        short=`Free shipping · US$${usd}+`;
      }
      if (status) {
        if (!status.subtotal) {text=`Free shipping on orders ${money(status.threshold)}+`;short=`Free shipping · ${money(status.threshold)}+`;}
        else if(status.unlocked) {text="You've unlocked free shipping";short='Free shipping unlocked';}
        else {text=status.remaining<=status.threshold*.2 ? `Just ${money(status.remaining)} more for free shipping` : `You're ${money(status.remaining)} away from free shipping`;short=`Free shipping · Add ${money(status.remaining)}`;}
      }
      this.querySelectorAll('[data-shipping-copy]').forEach(el=>{
        if(el.dataset.full===text || el.pendingFull===text) return;
        this.updateCopy(el,text,short);
      });
    }
    async updateCopy(el,full,short) {
      const next=window.innerWidth<750 && short ? short : full;
      if(this.motion.matches || !this.current?.el.contains(el) || !this.dataset.ready || el.textContent===next) {
        el.copyUpdate=null;el.pendingFull=null;el.getAnimations().forEach(animation=>animation.cancel());
        el.dataset.full=full;el.dataset.short=short;
        if(el.textContent!==next) el.textContent=next;
        this.fitCopy();return;
      }
      const token={};el.copyUpdate=token;el.pendingFull=full;
      const opacity=getComputedStyle(el).opacity;
      el.getAnimations().forEach(animation=>animation.cancel());
      const fade=el.animate([{opacity},{opacity:0}],{duration:180,easing:'ease',fill:'forwards'});
      try {await fade.finished;} catch(_){return;}
      if(!el.isConnected || el.copyUpdate!==token) return;
      el.dataset.full=full;el.dataset.short=short;
      const text=window.innerWidth<750 && short ? short : full;
      if(el.textContent!==text) el.textContent=text;
      this.fitCopy();
      const enter=el.animate([{opacity:0},{opacity:1}],{duration:280,easing:'ease'});fade.cancel();
      try {await enter.finished;} catch(_){}
      if(el.copyUpdate===token) el.pendingFull=null;
    }
    // One cancellable layout owner. Natural-size preparation, measurement and
    // final geometry are separate frames: never measure the next copy after a write.
    fitCopy() {
      if (!this.controller || !this.isConnected) return;
      this.layoutPending=true;
      if (!this.layoutBusy && !this.layoutFrame) this.layoutNext(() => this.prepareLayout());
    }
    placeDecorations() {this.fitCopy();}
    offset() {this.fitCopy();}
    layoutNext(callback) {
      this.layoutFrame=requestAnimationFrame(() => {
        this.layoutFrame=0;
        if (this.controller && this.isConnected) callback();
      });
    }
    copyMeasurement(el, rootWidth, stageWidth) {
      const compact=innerWidth<750,text=compact && el.dataset.short ? el.dataset.short : el.dataset.full;
      const style=getComputedStyle(el),parent=getComputedStyle(el.parentElement);
      const width=el.clientWidth,scroll=el.scrollWidth,base=parseFloat(style.fontSize);
      // Store the fitted geometry, not a width inferred from text length or canvas.
      // Parent metrics detect inherited/base-font changes even while an inline fit exists.
      const siblings=[...el.parentElement.children].filter(child=>child!==el).map(child=>child.getBoundingClientRect().width);
      const input=JSON.stringify([innerWidth,rootWidth,stageWidth,text,parent.font,parent.columnGap,style.fontFamily,style.fontWeight,style.fontStyle,style.fontStretch,this.fontVersion,siblings]);
      const key=JSON.stringify([input,width,scroll,style.font,style.letterSpacing]);
      return {el,text,key,input,base,width,scroll};
    }
    prepareLayout() {
      this.layoutBusy=true;this.layoutPending=false;this.measuredInputs=null;
      const rootWidth=this.getBoundingClientRect().width,stageWidth=this.stage.getBoundingClientRect().width;
      const copies=[...this.querySelectorAll('.mka-copy')].map(el=>this.copyMeasurement(el,rootWidth,stageWidth));
      const dirty=copies.filter(copy=>copy.el.textContent!==copy.text || this.copyMeasurements.get(copy.el)!==copy.key);
      const icons=[];
      if (this.iconsPending) this.querySelectorAll('.mka-symbol svg').forEach(svg=>{
        try {
          const box=svg.getBBox(),size=Math.max(box.width,box.height)+4;
          if (size>4) icons.push([svg,`${box.x+box.width/2-size/2} ${box.y+box.height/2-size/2} ${size} ${size}`]);
        } catch (_) {}
      });
      this.iconsPending=false;
      let wrote=false;
      for (const copy of dirty) {
        const {el,text}=copy;
        if (el.textContent!==text) {el.textContent=text;wrote=true;}
        if (el.style.getPropertyValue('font-size')) {el.style.removeProperty('font-size');wrote=true;}
      }
      for (const {el} of copies) if (el.title!==el.dataset.full) {el.title=el.dataset.full;wrote=true;}
      for (const [svg,viewBox] of icons) if (svg.getAttribute('viewBox')!==viewBox) {svg.setAttribute('viewBox',viewBox);wrote=true;}
      if (dirty.length) this.layoutNext(() => this.measureLayout(dirty));
      else if (wrote) this.layoutNext(() => this.finishLayout());
      else this.finishLayout();
    }
    measureLayout(copies) {
      // All copies are at their CSS base size here. Preserve the original quarter-px
      // calculation and 9px floor; a later expansion always starts from base again.
      const rootWidth=this.getBoundingClientRect().width,stageWidth=this.stage.getBoundingClientRect().width;
      const measured=copies.map(({el})=>this.copyMeasurement(el,rootWidth,stageWidth));
      this.measuredInputs=new Map(measured.map(({el,input})=>[el,input]));
      const sizes=measured.map(({el,base,width,scroll})=>[el,width>0 && scroll>width ? `${Math.max(9,Math.floor(base*width/scroll*4)/4)}px` : '']);
      for (const [el,size] of sizes) {
        if (el.style.getPropertyValue('font-size')!==size) {
          if (size) el.style.setProperty('font-size',size);
          else el.style.removeProperty('font-size');
        }
      }
      this.layoutNext(() => this.finishLayout());
    }
    writeLayoutStyle(el, name, value) {
      this.layoutStyles ||= new WeakMap();
      const values=this.layoutStyles.get(el) || {},old=values[name],actual=el.style.getPropertyValue(name);
      // CSSOM serializes fractional px with fewer digits than DOMRect supplies.
      if (actual!==value && !(old?.value===value && old.actual===actual)) el.style.setProperty(name,value);
      values[name]={value,actual:el.style.getPropertyValue(name)};this.layoutStyles.set(el,values);
    }
    finishLayout() {
      const root=this.getBoundingClientRect(),stageWidth=this.stage.getBoundingClientRect().width,compact=innerWidth<750,gap=compact?7:18;
      const prev=this.querySelector('[data-prev]').getBoundingClientRect(),next=this.querySelector('[data-next]').getBoundingClientRect();
      const copies=[...this.querySelectorAll('.mka-copy')].map(el=>this.copyMeasurement(el,root.width,stageWidth));
      const zones=[];
      for (const slide of this.slides) {
        const parts=[...slide.el.querySelector('.mka-message').children].filter(el=>getComputedStyle(el).display!=='none'&&!el.hidden).map(el=>el.getBoundingClientRect());
        if (!parts.length) continue;
        const surface=this.querySelector(`[data-surface="${CSS.escape(slide.id)}"]`);if(!surface)continue;
        const left=Math.min(...parts.map(p=>p.left))-gap,right=Math.max(...parts.map(p=>p.right))+gap;
        for (const [side,x,width] of [['left',prev.right-root.left+gap,left-prev.right-gap],['right',right-root.left,next.left-right-gap]]) {
          const zone=surface.querySelector(`.mka-decor-${side}`);
          if (zone) zones.push({zone,left:`${x}px`,width:`${Math.max(0,width)}px`,hidden:width<24,compact:width<78});
        }
      }
      const height=this.hidden?'0px':`${root.height}px`;
      const offsets=[['--mka-offset',this.dataset.sticky==='true'?height:'0px'],['--announcement-bar-height',height]];
      // Commit only after every geometry/computed-style read, including all surfaces.
      for (const {el,key,input,text} of copies) {
        if (el.textContent!==text || this.measuredInputs?.has(el) && this.measuredInputs.get(el)!==input) {
          // A resize/font/timer/content change between frames cannot bless a stale fit.
          this.copyMeasurements.delete(el);this.layoutPending=true;
        } else this.copyMeasurements.set(el,key);
      }
      this.measuredInputs=null;
      for (const item of zones) {
        const {zone}=item;
        this.writeLayoutStyle(zone,'left',item.left);
        this.writeLayoutStyle(zone,'width',item.width);
        if (zone.hidden!==item.hidden) zone.hidden=item.hidden;
        if (zone.classList.contains('is-compact')!==item.compact) zone.classList.toggle('is-compact',item.compact);
      }
      for (const [name,value] of offsets) if (document.documentElement.style.getPropertyValue(name)!==value) document.documentElement.style.setProperty(name,value);
      this.layoutBusy=false;
      if (this.layoutPending) this.fitCopy();
    }
  }
  customElements.define('mk-announcement',Announcement);
})();
